// Nodus custom JavaScript
(function () {
  "use strict";

  // Expandable content functionality for product description
  function initExpandableContent() {
    const expandableContainers = document.querySelectorAll(
      ".product-content-expandable",
    );

    expandableContainers.forEach((container) => {
      const toggle = container.querySelector(
        ".product-content-expandable__toggle",
      );
      const content = container.querySelector(
        ".product-content-expandable__content",
      );

      if (!toggle || !content) return;

      // Set initial height
      const contentInner = content.querySelector(
        ".product-content-expandable__content-inner",
      );
      if (contentInner) {
        content.style.height = "0px";
        container.classList.add("product-content-expandable--collapsed");
      }

      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        const isExpanded = container.classList.contains(
          "product-content-expandable--expanded",
        );

        if (isExpanded) {
          // Collapse
          const currentHeight = content.scrollHeight;
          content.style.height = currentHeight + "px";

          // Force reflow
          content.offsetHeight;

          requestAnimationFrame(() => {
            content.style.height = "0px";
            container.classList.remove("product-content-expandable--expanded");
            container.classList.add("product-content-expandable--collapsed");
            toggle.setAttribute("aria-expanded", "false");
          });
        } else {
          // Expand
          container.classList.remove("product-content-expandable--collapsed");
          container.classList.add("product-content-expandable--expanded");
          toggle.setAttribute("aria-expanded", "true");

          const targetHeight = content.scrollHeight;
          content.style.height = targetHeight + "px";

          // Remove height after animation
          const handleTransitionEnd = () => {
            content.style.height = "";
            content.removeEventListener("transitionend", handleTransitionEnd);
          };
          content.addEventListener("transitionend", handleTransitionEnd);
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initExpandableContent);
  } else {
    initExpandableContent();
  }

  // Re-initialize for dynamic content (e.g., AJAX loaded product pages)
  if (typeof window.themeCore !== "undefined" && window.themeCore.utils) {
    const originalInit = window.themeCore.utils.initDynamicContent;
    if (originalInit) {
      window.themeCore.utils.initDynamicContent = function () {
        originalInit.apply(this, arguments);
        initExpandableContent();
      };
    }
  }
})();

class ShowOnlyMenu {
  constructor() {
    this.headerMain = document.querySelector(".header__main");
    this.header = document.querySelector(
      ".shopify-section-group-header-group-with-cart-drawer",
    );
    this.init();
  }

  init() {
    window.addEventListener("scroll", () => {
      if (!this.headerMain || !this.header) return;

      const hidden = window.scrollY > 300;
      const show = window.scrollY < 250;
      let isCollapsed = this.header.classList.contains("is-collapsed");

      if (hidden) {
        this.header.classList.add("header-hide");
      }
      if (show) {
        this.header.classList.remove("header-hide");
      }
    });
  }
}

class MoveSearchIcon {
  constructor() {
    this.searchIcon = document.querySelector(".header__icon--search");
    this.utils = document.querySelector(".header__utils");
    this.leftIcons = document.querySelector(".header__left-icons");

    this.init();
  }

  init() {
    if (!this.searchIcon || !this.utils || !this.leftIcons) return;

    this.handleMove(); // İlk çalıştırma
    window.addEventListener("resize", () => this.handleMove());
  }

  handleMove() {
    if (window.innerWidth < 1200) {
      this.moveToLeft();
    } else {
      this.moveToUtils();
    }
  }

  moveToLeft() {
    if (!this.leftIcons.contains(this.searchIcon)) {
      this.leftIcons.appendChild(this.searchIcon);
    }
  }

  moveToUtils() {
    if (!this.utils.contains(this.searchIcon)) {
      this.utils.appendChild(this.searchIcon);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new ShowOnlyMenu();
  // new MoveSearchIcon();
});

// Zoom modal cleanup: remove lingering mouse handlers that can cause "stuck" drag state
(function () {
  function cleanupZoomHandlers() {
    try {
      document
        .querySelectorAll("[data-zoom-container]")
        .forEach((container) => {
          const h = container._zoomHandlers;
          if (h) {
            try {
              container.removeEventListener("mousedown", h.down);
              document.removeEventListener("mousemove", h.move);
              document.removeEventListener("mouseup", h.up);
            } catch (e) {}
            try {
              delete container._zoomHandlers;
            } catch (e) {}
          }
        });

      // reset any global drag flags if present
      try {
        if (window.themeCore) window.themeCore._zoomDrag = false;
      } catch (e) {}
    } catch (e) {
      // ignore
    }
  }

  // Observe zoom modals and cleanup when they close
  function initZoomCleanup() {
    const modals = document.querySelectorAll("[data-zoom-modal]");
    if (!modals.length) return;
    modals.forEach((modal) => {
      const mo = new MutationObserver(() => {
        const isOpen =
          modal.classList.contains("is-active") ||
          modal.classList.contains("active") ||
          modal.hasAttribute("data-open");
        if (!isOpen) cleanupZoomHandlers();
      });
      mo.observe(modal, {
        attributes: true,
        attributeFilter: ["class", "data-open"],
      });
    });
    // Also bind to global event if theme emits it
    try {
      if (
        window.themeCore &&
        window.themeCore.EventBus &&
        window.themeCore.EventBus.listen
      ) {
        window.themeCore.EventBus.listen("product:zoom:open", () => {});
        // Listen for any toggle close events (specific IDs used by theme code)
        // We'll also do a periodic safety cleanup when visibility changes
        window.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") cleanupZoomHandlers();
        });
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZoomCleanup);
  } else {
    initZoomCleanup();
  }
})();

class HeaderPredictiveSearch {
  constructor() {
    this.form = document.querySelector(".header_inline_search .search__form");
    this.searchInput = document.querySelector(
      ".header_inline_search .search__input",
    );
    this.searchWrapper = document.querySelector(
      ".header_inline_search .input-wrapper",
    );
    this.searchTypeInput = this.form
      ? this.form.querySelector("input[name='type']")
      : null;
    this.dropdownContainer = null;
    this.debounceTimer = null;
    this.activeRequestController = null;
    this.requestId = 0;
    this.init();
  }

  init() {
    if (!this.searchInput || !this.searchWrapper || !this.form) {
      return;
    }

    this.createDropdownContainer();

    // Add active class on mouseenter (hover)
    this.searchInput.addEventListener("mouseenter", () => {
      this.searchInput.classList.add("active");
    });

    // Remove active class on mouseleave only if no text
    this.searchInput.addEventListener("mouseleave", () => {
      const searchTerm = this.searchInput.value.trim();
      if (searchTerm.length === 0) {
        this.searchInput.classList.remove("active");
      }
    });

    // Search input
    this.searchInput.addEventListener("input", (e) => {
      const searchTerm = this.searchInput.value.trim();
      if (searchTerm.length > 0) {
        this.searchInput.classList.add("active");
        this.debounceSearch(searchTerm);
      } else {
        this.searchInput.classList.remove("active");
        this.invalidatePendingSearch();
        this.closeDropdown();
      }
    });

    this.searchInput.addEventListener("focus", () => {
      this.searchInput.classList.add("active");
      const searchTerm = this.searchInput.value.trim();
      if (searchTerm.length > 0) {
        this.debounceSearch(searchTerm);
      }
    });

    // Remove active on blur only if no text
    this.searchInput.addEventListener("blur", () => {
      const searchTerm = this.searchInput.value.trim();
      if (searchTerm.length === 0) {
        this.searchInput.classList.remove("active");
      }
    });

    this.searchInput.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.invalidatePendingSearch();
        this.closeDropdown();
      }
    });

    // Close on click outside
    document.addEventListener("click", (e) => {
      if (
        !this.searchWrapper.contains(e.target) &&
        !this.dropdownContainer.contains(e.target)
      ) {
        this.invalidatePendingSearch();
        this.closeDropdown();
      }
    });
  }

  createDropdownContainer() {
    this.dropdownContainer = document.createElement("div");
    this.dropdownContainer.className = "header-search-dropdown";
    this.dropdownContainer.style.cssText = `
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: white;
      border: 1px solid #ddd;
      border-top: none;
      border-radius: 0 0 8px 8px;
      max-height: 600px;
      overflow-y: auto;
      display: none;
      z-index: 100;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      padding: 16px;
    `;

    this.searchWrapper.style.position = "relative";
    this.searchWrapper.parentElement.appendChild(this.dropdownContainer);
  }

  debounceSearch(searchTerm) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.getSearchResults(searchTerm);
    }, 300);
  }

  getSearchTypeValue() {
    if (!this.searchTypeInput) {
      return "product";
    }
    const value = this.searchTypeInput.value
      ? this.searchTypeInput.value.trim()
      : "";
    return value || "product";
  }

  abortActiveRequest() {
    if (!this.activeRequestController) {
      return;
    }
    this.activeRequestController.abort();
    this.activeRequestController = null;
  }

  invalidatePendingSearch() {
    clearTimeout(this.debounceTimer);
    this.requestId += 1;
    this.abortActiveRequest();
  }

  getSearchResults(searchTerm) {
    const activeRequestId = ++this.requestId;
    this.abortActiveRequest();
    this.activeRequestController = new AbortController();

    const url = new URL(
      `${window.Shopify.routes.root}search/suggest`,
      window.location.origin,
    );
    url.searchParams.set("q", searchTerm);
    url.searchParams.set("resources[type]", this.getSearchTypeValue());
    url.searchParams.set("resources[limit]", "5");
    url.searchParams.set("options[prefix]", "last");
    url.searchParams.set("section_id", "predictive-search");

    fetch(url.toString(), { signal: this.activeRequestController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        if (activeRequestId !== this.requestId) {
          return;
        }
        if (!this.searchInput.value.trim().length) {
          return;
        }
        this.parseAndDisplay(text);
      })
      .catch((error) => {
        if (error && error.name === "AbortError") {
          return;
        }
        console.error("[HeaderPredictiveSearch]", error);
        this.closeDropdown();
      });
  }

  parseAndDisplay(html) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const section = doc.querySelector("#shopify-section-predictive-search");

      if (!section) {
        this.closeDropdown();
        return;
      }

      const resultRows = Array.from(
        section.querySelectorAll(".js-predictive-search-result-row"),
      );
      const resultRow =
        resultRows.find(
          (row) =>
            row.dataset.id === "product" &&
            row.querySelector(".predictive-search__result-col"),
        ) ||
        resultRows.find((row) =>
          row.querySelector(".predictive-search__result-col"),
        );

      if (!resultRow) {
        this.showNoResults();
        return;
      }
      const productItems = resultRow.querySelectorAll(
        ".predictive-search__result-col",
      );
      const limitedProducts = Array.from(productItems).slice(0, 5);

      if (limitedProducts.length === 0) {
        this.showNoResults();
        return;
      }
      let dropdownHTML =
        '<div style="display: grid; grid-template-columns: repeat(5, minmax(150px, 1fr)); gap: 12px;">';

      limitedProducts.forEach((item) => {
        // Get the full product card HTML from theme
        const productCard = item.innerHTML;
        dropdownHTML += `<div style="position: relative;">${productCard}</div>`;
      });

      dropdownHTML += "</div>";

      this.dropdownContainer.innerHTML = dropdownHTML;
      this.openDropdown();
    } catch (error) {
      console.error("Parse error:", error);
      this.closeDropdown();
    }
  }

  showNoResults() {
    this.dropdownContainer.innerHTML = `
      <div style="padding: 16px; text-align: center; color: #999; font-size: 14px;">
        Ürün bulunamadı
      </div>
    `;
    this.openDropdown();
  }

  openDropdown() {
    this.dropdownContainer.style.display = "block";
  }

  closeDropdown() {
    this.dropdownContainer.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (!window.__headerPredictiveSearchInitialized) {
    window.__headerPredictiveSearchInitialized = true;
    new HeaderPredictiveSearch();
  }
});
